<template>
  <span :class="`aha-badge aha-badge-${size}`">{{ label }}</span>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: 'md',
    },
  },
}
</script>

<style lang="scss" scoped>
  .aha-badge {
    @apply px-2 py-1 rounded-2xl text-base-0 font-bold text-center cursor-default;
  }
  .aha-badge-sm {
    @apply text-sm py-0.5;
  }
  .aha-badge-3xs {
    @apply text-3xs py-0.5 px-0.75;
  }
  .aha-badge-lg {
    @apply text-lg;
  }
</style>
